import { render, staticRenderFns } from "./KvisitSetting.vue?vue&type=template&id=474148ca"
import script from "./KvisitSetting.vue?vue&type=script&lang=js"
export * from "./KvisitSetting.vue?vue&type=script&lang=js"
import style0 from "./KvisitSetting.vue?vue&type=style&index=0&id=474148ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports